var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 41,
    viewBox: "0 0 60 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 41,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HOME"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-141 -1070H5361V365H-141V-1070Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-141 -1070V-1071H-142V-1070H-141ZM5361 -1070H5362V-1071H5361V-1070ZM5361 365V366H5362V365H5361ZM-141 365H-142V366H-141V365ZM-141 -1069H5361V-1071H-141V-1069ZM5360 -1070V365H5362V-1070H5360ZM5361 364H-141V366H5361V364ZM-140 365V-1070H-142V365H-140Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Home"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-40 -969)",
    fill: "url(#paint0_linear_23057_2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "App Bar"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40.25,
    y: -14.25,
    width: 1440.5,
    height: 69.5,
    fill: "#20232E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.25,
    y: -14.25,
    width: 1440.5,
    height: 69.5,
    stroke: "#526283",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LOGO MB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M54.3885 22.6152C56.2373 21.4531 57.8395 19.4282 58.0684 17.2977C58.491 13.5121 56.4309 10.642 53.8074 9.33904C50.6732 7.77196 52.7685 8.89885 40.7601 5.16603C34.9848 3.37005 34.6151 1.69732 34.7559 0.5C33.1888 1.71493 32.7134 8.28258 35.425 10.2546C38.207 12.2795 43.7358 12.7021 50.6908 15.0439C56.8007 17.0688 55.8851 20.8544 54.3885 22.6152Z",
    fill: "url(#paint1_linear_23057_2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M55.6163 23.7423C55.088 23.3725 54.507 23.0556 53.8907 22.8267C45.1925 20.4673 44.4178 20.5201 41.5478 19.6925C33.6771 17.4388 34.6279 15.5547 34.4343 14.7976C32.9904 16.6288 32.9552 22.3337 35.6492 24.0592C38.9066 26.1369 44.6467 26.8236 51.9187 28.9542C54.2781 29.6585 55.6691 30.486 56.7079 31.4544C57.8524 32.5461 58.1694 34.1484 57.289 35.4866C56.5143 36.6663 54.4542 36.4726 52.1828 36.0853C48.133 35.4162 43.0092 34.0252 41.5654 33.5674C35.0857 31.4544 34.6456 29.4296 34.4519 28.6724C33.008 30.5036 32.9728 36.2085 35.6668 37.9165C37.7973 39.2722 39.8222 40.0646 44.2065 40.3639C47.4111 40.5928 53.2568 40.8041 56.1093 37.3002C56.391 36.9656 58.6096 34.976 59.0674 31.5425C59.4723 28.3731 57.9933 25.3974 55.6163 23.7423Z",
    fill: "url(#paint2_linear_23057_2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M48.7651 21.4882C51.371 22.1573 53.8889 22.844 53.8889 22.844C53.9241 22.8616 53.977 22.8792 54.0122 22.8968C54.1354 22.8088 54.2587 22.7207 54.3819 22.6327C55.8786 20.8719 56.7942 17.0863 50.6667 15.0262C50.2441 14.8853 49.8216 14.7445 49.4166 14.6212C51.1421 15.4312 53.5544 19.8859 48.7651 21.4882Z",
    fill: "url(#paint3_linear_23057_2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M50.368 35.3457C50.2448 35.4514 50.1391 35.557 49.9983 35.6451C50.7202 35.8211 51.4597 35.962 52.1464 36.0676C54.4354 36.4374 56.4955 36.6311 57.2526 35.469C58.133 34.1308 57.8161 32.5285 56.6716 31.4368C54.7699 29.6232 52.3049 29.0246 49.8046 28.3379C51.6534 29.3415 53.1853 32.687 50.368 35.3457Z",
    fill: "url(#paint4_linear_23057_2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.1116 10.1315C19.9847 7.47279 18.0478 5.16619 16.0053 4.83164C12.3606 4.23298 9.64898 7.22628 8.39884 11.0471C6.90218 15.6075 7.97625 12.5614 4.45472 29.9578C2.76439 38.3214 1.16209 38.8672 -1.52588e-05 38.6912C1.16209 40.9449 7.46563 41.5964 9.33204 37.6699C11.2689 33.6378 11.6386 25.6263 13.8396 15.5371C15.794 6.68045 19.4212 7.9658 21.1116 10.1315Z",
    fill: "url(#paint5_linear_23057_2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.1691 8.33546C21.817 9.1102 21.5176 9.93776 21.3063 10.8358C19.0878 23.4428 19.1406 24.5521 18.3659 28.7251C16.2353 40.1173 14.4394 38.7615 13.7174 39.0608C15.4782 41.1561 20.9542 41.1561 22.5741 37.2472C24.5461 32.5108 25.1624 24.2176 27.1873 13.6706C27.8388 10.2371 28.6311 8.22982 29.5643 6.73317C30.6032 5.06044 32.135 4.60264 33.4204 5.87039C34.5473 6.97967 34.3712 9.95537 34.0191 13.2656C33.4028 19.129 32.0998 26.5594 31.6596 28.6547C29.67 38.0396 27.7331 38.6911 27.0112 38.9904C28.772 41.0857 34.248 41.0857 35.8679 37.1768C37.1532 34.0779 37.8927 31.155 38.1745 24.7986C38.3682 20.1502 38.5442 11.6985 35.1812 7.57833C34.8466 7.17336 32.945 3.96877 29.6524 3.31728C26.5886 2.73623 23.7538 4.90197 22.1691 8.33546Z",
    fill: "url(#paint6_linear_23057_2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M20.0507 18.2486C20.667 14.4806 21.3185 10.8358 21.3185 10.8358C21.3361 10.7654 21.3537 10.7125 21.3713 10.6597C21.2833 10.4836 21.2128 10.3076 21.1248 10.1315C19.4168 7.96574 15.8073 6.68038 13.8704 15.537C13.7296 16.1533 13.6063 16.752 13.4831 17.3506C14.2402 14.8679 18.4836 11.3288 20.0507 18.2486Z",
    fill: "url(#paint7_linear_23057_2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M33.3291 15.8541C33.4347 16.0302 33.5404 16.1887 33.6284 16.3823C33.7869 15.3259 33.9278 14.2694 34.0334 13.2834C34.3856 9.97315 34.5616 6.99746 33.4347 5.88818C32.1494 4.62043 30.6175 5.07823 29.5787 6.75095C27.8531 9.51535 27.2897 13.0897 26.6558 16.6993C27.5714 14.0405 30.7408 11.8043 33.3291 15.8541Z",
    fill: "url(#paint8_linear_23057_2)"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23057_2",
    x1: 0.0000240137,
    y1: 1.17006,
    x2: 1544.95,
    y2: 197.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#263A40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191B24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23057_2",
    x1: 65.9672,
    y1: 13.7603,
    x2: 29.2658,
    y2: 9.98172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#4CE5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#076266"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_23057_2",
    x1: 33.4588,
    y1: 27.6353,
    x2: 59.1343,
    y2: 27.6353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#076266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4CE5AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_23057_2",
    x1: 52.5508,
    y1: 17.8047,
    x2: 47.6998,
    y2: 23.9427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#076266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4CE5AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_23057_2",
    x1: 53.8438,
    y1: 31.0794,
    x2: 50.736,
    y2: 41.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#076266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4CE5AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_23057_2",
    x1: 13.5391,
    y1: -6.12523,
    x2: 8.40216,
    y2: 46.1035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#4CE5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#076266"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_23057_2",
    x1: 26.017,
    y1: 40.4313,
    x2: 25.8483,
    y2: 3.24957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#076266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4CE5AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_23057_2",
    x1: 16.292,
    y1: 12.8839,
    x2: 23.6554,
    y2: 18.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#076266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119792,
    stopColor: "#0D777F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177083,
    stopColor: "#118590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4CE5AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_23057_2",
    x1: 29.3751,
    y1: 10.946,
    x2: 40.0948,
    y2: 14.0562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#076266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4CE5AE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMb);
export default __webpack_public_path__ + "static/media/LOGO-MB.fa94f402c9be9c75931802e59794fd88.svg";
export { ForwardRef as ReactComponent };